export default __webpack_public_path__ + "locales/lo-LA/PortalUnavailable.json?hash=f91a95c8d92bd76c148ce607e075f45b";